import React from "react";
import { graphql } from "gatsby";
import Blogpost from "../components/blogpost";
import SEO from "../components/seo/seo"
import "./blogTemplate.css";

const classes = {
  wrapper: 'mt-8 blog-content',
  title: 'mt-16 text-4xl text-gray-900 font-bold',
  date: 'text-gray-600 font-light',
  hr: 'mt-8 max-w-150 border-t-2',
};

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark


  return (
    <Blogpost>
        <SEO title={frontmatter.title}/>
        <h1 className={classes.title}>{frontmatter.title}</h1>
        <p className={classes.date}>Posted on {frontmatter.date}</p>
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <hr className="hr"></hr>
    </Blogpost>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`
